module.exports = __webpack_public_path__ + "static/media/prnts-logo.4b56c01c.png";